/* ---- Core ---- */
import { createRouter, createWebHistory } from 'vue-router';

/* ---- Others ---- */
// import authApi from '@services/authApiService';

/* ---- Components ---- */
import HomePage from '@/views/HomePage.vue';
import AuthPage from '@/views/AuthPage.vue';
import NotFoundPage from '@/views/NotFoundPage.vue';

/* ---- Routes ---- */
const routes = [
  { name: 'home', path: '/', component: HomePage },
  { name: 'auth', path: '/auth', component: AuthPage },
  {
    name: 'error',
    path: '/error',
    redirect: () => {
      return 'auth';
    },
  },
  { name: '404', path: '/404', component: NotFoundPage },
  { path: '/:catchAll(.*)', redirect: '404' },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: 'link-active',
});

router.beforeEach((to, from, next) => {
  if (to.name === 'home') {
    next({
      name: 'auth',
    });
  } else next();
});
